import { render } from "./YouTubeCustom.vue?vue&type=template&id=65233b3e"
import script from "./YouTubeCustom.vue?vue&type=script&lang=js"
export * from "./YouTubeCustom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/invokingyell/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__